import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
//import WhyUs from '../views/WhyUs.vue'
import CapitalInvestment from '../views/CapitalInvestment.vue'
import PartnersForGrowth from '../views/PartnersForGrowth.vue'
import Trustworthiness from '../views/Trustworthiness.vue'
import Investments from '../views/Investments.vue'
import BetterPerformance from '../views/BetterPerformance.vue'
import Securities from '../views/Securities.vue'
import ShareholderRelations from '../views/ShareholderRelations.vue'
import StockQuote from '../views/StockQuote.vue'
import SunavalFilings from '../views/SunavalFilings.vue'
import PressRelease from '../views/PressRelease.vue'
import PostView from '../views/PostView.vue'
import Contact from '../views/Contact.vue'
import NotFound from '../views/NotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: {
        es: 'Inicio | CrecePymes',
        en: 'Home | CrecePymes'
      }
    }
  },
  {
    path: '/about-us',
    name: 'About',
    component: About,
    meta: {
      title: {
        es: 'Sobre nosotros | CrecePymes',
        en: 'About Us | CrecePymes'
      }
    }
  },
  {
    path: '/partners-for-growth',
    name: 'PartnersForGrowth',
    component: PartnersForGrowth,
    meta: {
      title: {
        es: 'Socios para Crecer | CrecePymes',
        en: 'Partners for Growth | CrecePymes'
      }
    }
  },
  {
    path: '/trustworthiness',
    name: 'Trustworthiness',
    component: Trustworthiness,
    meta: {
      title: {
        es: 'Confiabilidad | CrecePymes',
        en: 'Trustworthiness | CrecePymes'
      }
    }
  },
  {
    path: '/investments',
    name: 'Investments',
    component: Investments,
    meta: {
      title: {
        es: 'Inversiones | CrecePymes',
        en: 'Investments | CrecePymes'
      }
    }
  },
  {
    path: '/better-performance',
    name: 'BetterPerformance',
    component: BetterPerformance,
    meta: {
      title: {
        es: 'Mejores Rendimientos | CrecePymes',
        en: 'Better Performance | CrecePymes'
      }
    }
  },
  /*{
    path: '/why-us',
    name: 'WhyUs',
    component: WhyUs,
    meta: {
      title: {
        es: 'Beneficios | CrecePymes',
        en: 'Why Us? | CrecePymes'
      }
    }
  },*/
  {
    path: '/capital-investment',
    name: 'CapitalInvestment',
    component: CapitalInvestment,
    meta: {
      title: {
        es: 'Inversion de Capital | CrecePymes',
        en: 'Capital Investment | CrecePymes'
      }
    }
  },
  {
    path: '/securities',
    name: 'Securities',
    component: Securities,
    meta: {
      title: {
        es: 'Emisiones | CrecePymes',
        en: 'Securities | CrecePymes'
      }
    }
  },
  {
    path: '/shareholder-relations',
    name: 'ShareholderRelations',
    component: ShareholderRelations,
    meta: {
      title: {
        es: 'Informacion para Accionistas | CrecePymes',
        en: 'Shareholder Relations | CrecePymes'
      }
    }
  },
  {
    path: '/stock-quote',
    name: 'StockQuote',
    component: StockQuote,
    meta: {
      title: {
        es: 'Cotización de Acción | CrecePymes',
        en: 'Stock Quote | CrecePymes'
      }
    }
  },
  {
    path: '/sunaval-filings',
    name: 'SunavalFilings',
    component: SunavalFilings,
    meta: {
      title: {
        es: 'Reportes SUNAVAL + Documentos Constitutivos | CrecePymes',
        en: 'Sunaval Filings | CrecePymes'
      }
    }
  },
  {
    path: '/press-release',
    name: 'PressRelease',
    component: PressRelease,
    meta: {
      title: {
        es: 'Notas de Prensa | CrecePymes',
        en: 'Press Release | CrecePymes'
      }
    },
    children: [
      {
        path: 'post/:id',
        name: 'PostView',
        component: PostView,
        meta: {
          title: {
            es: 'Post | CrecePymes',
            en: 'Post | CrecePymes'
          }
        }
      },
    ]
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      title: {
        es: 'Contacto | CrecePymes',
        en: 'Contact Us | CrecePymes'
      }
    }
  },
  { 
    path: '/error/404', 
    component: NotFound,
    meta: {
      title: {
        es: '404 | CrecePymes',
        en: '404 | CrecePymes'
      }
    }
  },  
  { path: '*', redirect: '/error/404' },  
]



const router = new VueRouter({
  mode: 'hash',
  base: '/',//process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if(to.name == 'PostView') return { x: 0, y: 120 }
    if(to.name != from.name) return { x: 0, y: 0 }
    
  }
})

export default router
